import { render, staticRenderFns } from "./VerificationNewDetail.vue?vue&type=template&id=36600bf6&"
import script from "./VerificationNewDetail.vue?vue&type=script&lang=js&"
export * from "./VerificationNewDetail.vue?vue&type=script&lang=js&"
import style0 from "./VerificationNewDetail.vue?vue&type=style&index=0&id=36600bf6&prod&lang=css&"
import style1 from "./VerificationNewDetail.vue?vue&type=style&index=1&id=36600bf6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports